import React, { useState } from 'react'
import { Button, Hidden, Menu, FormGroup, TextField, FormControl, FormLabel, IconButton } from '@mui/material'
import TuneRoundedIcon from '@mui/icons-material/TuneRounded'
import ClearRoundedIcon from '@mui/icons-material/ClearRounded'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import styles from '../../Common/_styles/filterListStyles'
import { useButtonsStyles, useFormsStyles } from '../../../styles'
import { PlannedConsultationListFilterProps, RequiredExpertsFilter } from './_props'
// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { root: { flexGr... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

const PlannedConsultationListFilter: React.FC<PlannedConsultationListFilterProps> = ({
    requiredExperts,
    handleFiltersChange,
    filters,
    handleResetFilter,
    disabled = false,
}) => {
    /* ### STYLES ### */
    const classes = useStyles()
    const buttonClasses = useButtonsStyles()
    const formsClasses = useFormsStyles()

    /* ### STATE ### */
    const [anchorEl, setAnchorEl] = useState(null)
    const menuOpen = Boolean(anchorEl)
    const [startDateCleared, setStartDateCleared] = useState(false)
    const [endDateCleared, setEndDateCleared] = useState(false)
    const hasFilterActive = !!(filters.startDate || filters.endDate)

    /* ### HANDLERS ### */
    const handleMenu = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleStartDateClear = () => {
        setStartDateCleared(true)
        handleFiltersChange({ startDate: undefined })
    }

    const handleEndDateClear = () => {
        setEndDateCleared(true)
        handleFiltersChange({ endDate: undefined })
    }

    return (
        <div className={classes.root}>
            <Button
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                className={clsx(hasFilterActive && buttonClasses.ButtonActive, buttonClasses.ButtonTextBlackFlat)}
                startIcon={<TuneRoundedIcon />}
                disabled={disabled}
            >
                <Hidden xsDown>Filtrer</Hidden>
            </Button>
            <Menu
                id="menu-filters"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={menuOpen}
                onClose={handleClose}
                className={classes.menu}
            >
                <div className={formsClasses.FormContainer}>
                    <FormControl component="fieldset" className={formsClasses.FormControl}>
                        <FormGroup aria-label="position" className={formsClasses.FormGroup}>
                            <FormLabel component="legend">Dates</FormLabel>
                            <div className={formsClasses.FormGroupContent}>
                                <TextField
                                    id="startDate"
                                    name="startDate"
                                    label="Date de début"
                                    type="date"
                                    className={formsClasses.FormTextField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        // @ts-expect-error TS(2322) FIXME: Type '{ endAdornment: JSX.Element; value?: string ... Remove this comment to see the full error message
                                        min: '2020-08-10',
                                        max: '2020-08-20',
                                        name: 'startDate',
                                        ...(startDateCleared
                                            ? {
                                                  value: '',
                                              }
                                            : {}),
                                        endAdornment: (
                                            <IconButton onClick={handleStartDateClear}>
                                                <ClearRoundedIcon />
                                            </IconButton>
                                        ),
                                    }}
                                    onChange={(e) => {
                                        setStartDateCleared(false)
                                        handleFiltersChange({ startDate: e.target.value })
                                    }}
                                />
                                <TextField
                                    id="endDate"
                                    name="endDate"
                                    label="Date de fin"
                                    type="date"
                                    className={formsClasses.FormTextField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        // @ts-expect-error TS(2322) FIXME: Type '{ endAdornment: JSX.Element; value?: string ... Remove this comment to see the full error message
                                        min: '2020-08-10',
                                        max: '2020-08-20',
                                        name: 'endDate',
                                        ...(endDateCleared
                                            ? {
                                                  value: '',
                                              }
                                            : {}),
                                        endAdornment: (
                                            <IconButton onClick={handleEndDateClear}>
                                                <ClearRoundedIcon />
                                            </IconButton>
                                        ),
                                    }}
                                    onChange={(e) => {
                                        setEndDateCleared(false)
                                        handleFiltersChange({ endDate: e.target.value })
                                    }}
                                />
                            </div>
                        </FormGroup>
                    </FormControl>
                    {hasFilterActive && (
                        <div className={formsClasses.FormContainerBottom}>
                            <Button
                                color="inherit"
                                className={formsClasses.FormContainerBottomResetButton}
                                onClick={() => {
                                    setStartDateCleared(true)
                                    setEndDateCleared(true)
                                    handleResetFilter()
                                }}
                                disabled={!hasFilterActive}
                            >
                                Réinitialiser les filtres
                            </Button>
                        </div>
                    )}
                </div>
            </Menu>
        </div>
    )
}

export default PlannedConsultationListFilter
